import React, { Component } from 'react'

class SocialProofSaving extends Component {
    render() {
        return <div className='social-proof-saving-container'>
            <div className='social-proof-saving-content'>
                Average savings per service when booked on Dealgrace ${this.props.saving}
            </div>
        </div>
    }
}

export default SocialProofSaving;